/* 陸遜傳・第 3 章：石亭、夾石（228 年）
 * 西邊是吳軍出發的地方（皖口一帶）。往東三條平行的山道：北道朱桓、中道陸遜、南道全琮，中間隔著岩脊與林子；
 * 三道在石亭會合（曹休的營），再往東是夾石：南北兩片大岩夾著的隘口。 */
export const START = [800, 2400], SHITING = [7500, 2400], JIASHI = [9500, 2400], END = [10000, 2400];
export const LANES = [1200, 2400, 3600], LANE_X0 = 1500, LANE_X1 = 6700;
export const AMBUSH = [[3200, 2250], [4800, 2560], [6100, 2250]]; // 中道旁的草叢（伏兵）
export default {
  id: 'luxun_shiting', name: '石亭', W: 10400, H: 4800, seed: 228,
  bases: [START, END],
  roads: [
    { pts: [START, [LANE_X0, LANES[1]], [LANE_X1, LANES[1]], SHITING, JIASHI, END], w: 150 },
    { pts: [START, [LANE_X0, LANES[0]], [LANE_X1, LANES[0]], SHITING], w: 130 },
    { pts: [START, [LANE_X0, LANES[2]], [LANE_X1, LANES[2]], SHITING], w: 130 },
  ],
  rocks: [[2700, 1800, 720, 150], [4300, 1800, 720, 150], [5850, 1800, 620, 150], [2700, 3000, 720, 150], [4300, 3000, 720, 150], [5850, 3000, 620, 150],
    [9500, 1250, 330, 820], [9500, 3550, 330, 820]],
  woods: 0.6,
  sight: 0.8,
  clearings: [[START[0], START[1], 500], [SHITING[0], SHITING[1], 650], [JIASHI[0], JIASHI[1], 220], [END[0], END[1], 300]],
  grass: AMBUSH.map(([x, y]) => [x, y, 230, 95]),
  tents: [{ x: SHITING[0], y: SHITING[1], n: 8, r: 480, chief: true, col: '#3b5a99', flag: '曹' }, { x: START[0], y: START[1], n: 5, r: 360, chief: true, col: '#b8433a', flag: '陸' }],
};
